const SeasoningModel = (data) => {
    return {...data.item, sourceItems: data.sourceItems}
}

export default SeasoningModel
